import { Component } from '@angular/core';

@Component({
    selector: 'vb-user-notifications-reminders',
    templateUrl: './user-notifications-reminders.component.html',
    styleUrls: ['./user-notifications-reminders.component.scss'],
})
export class UserNotificationsRemindersComponent {}
